export default {
  bind: (el, binding, vnode) => {
    $(el).on(`click.${vnode.key}${binding.expression}`, (e) => {
      e.stopPropagation();
    });
    $('body').on(`click.${vnode.key}${binding.expression}`, (e) => binding.value(binding.arg));
  },

  unbind(el, binding, vnode) {
    $(el).off(`click.${vnode.key}${binding.expression}`);
    $('body').off(`click.${vnode.key}${binding.expression}`);
  }
}